import styled from "styled-components";
import {BaseEntity, DataScope, isSuperUser, Person, StyledBaseProps} from "@betrue/shared/interfaces";

interface AdminZoneProps extends StyledBaseProps {
  principal: Person
  subject: BaseEntity
}

export const AdminZone = styled((props: AdminZoneProps) => (
  <div className={props.className}>
    {props.subject.dataScope === DataScope.FULL ? (<div className={'warning-zone'}>{props.children}</div>) : ''}
  </div>
))`
  & {
    .warning-zone {
      padding: ${(props) => props.theme.spacing(1)};
      background-color: ${(props) => props.theme.colors.admins};
    }

  }
`
